import React from 'react';
import { Card, Space, Tag } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';

const colorCodes = {
    "1": { background: "#FFA07A", titleColor: "#000000" },
    "2": { background: "#B6E37D", titleColor: "#000000" },
    "3": { background: "#6A9EEB", titleColor: "#FFFFFF" },
    "4": { background: "#496A9F", titleColor: "#FFFFFF" },
    "5": { background: "#FFF4B1", titleColor: "#000000" },
    "6": { background: "#FF7F7F", titleColor: "#FFFFFF" },
    "7": { background: "#6C7A9F", titleColor: "#FFFFFF" },
    "8": { background: "#6BAED6", titleColor: "#FFFFFF" },
    "9": { background: "#808080", titleColor: "#FFFFFF" },
    "11": { background: "#D1CC6F", titleColor: "#FFFFFF" },
    "12": { background: "#F6E597", titleColor: "#000000" },
    "376": { background: "#A86B6B", titleColor: "#FFFFFF" }
};

export function RankingComponent(props) {

    // オブジェクトの配列をCSV文字列に変換する関数
    function convertToCSV(objects) {
        const header = objects.column_list.join(','); // Use column_list for CSV header
        const rows = objects.data_list.map(row =>
            row.map(field => `"${field.toString().replace(/"/g, '""')}"`).join(',')
        );
        return [header, ...rows].join('\r\n');
    }

    function OnDownloadRanking(event, ranking) {
        const filename = `${ranking.title}.csv`; // Use ranking title as the filename
        if (!ranking.data_list || ranking.data_list.length === 0) return; // Skip if no data
        const csvData = new Blob([convertToCSV(ranking)], { type: 'text/csv;charset=utf-8;' });
        const csvURL = URL.createObjectURL(csvData);
        const downloadLink = document.createElement("a");
        downloadLink.href = csvURL;
        downloadLink.setAttribute("download", filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    // 背景色とタイトル色を返す関数
    function get_color_code(team_id) {
        return colorCodes[String(team_id)] || { background: null, titleColor: null };
    }

    const { ranking, player_id, team_id } = props;

    return (
        <Space direction="vertical" size={16}>
            {ranking && ranking.map((rankingItem, index) => {  // rankingを直接使用
                if (rankingItem.player_id_list.length === 1) {
                    var { background, titleColor } = get_color_code(rankingItem.team_id_list[0]);
                }

                return (
                    <div key={index}>
                        <style>{`
                            .custom-card-${index} .ant-card-head-wrapper {
                                background: none !important;
                            }
                        `}</style>
                        <Card
                            className={`custom-card-${index}`}
                            title={
                                <span style={{ color: titleColor }}>
                                    <strong className="player_name">{rankingItem.player_name}</strong>
                                    {rankingItem.title}<br />
                                    <span className="recommend_comment" style={{ display: 'none' }}>{rankingItem.comment}</span>
                                </span>
                            }
                            extra={
                                <div>
                                    {rankingItem.tag_name_list.map((tag, idx) => (
                                        <Tag key={idx}>{tag}</Tag>
                                    ))}
                                </div>
                            }
                            style={{
                                width: 360,
                            }}
                            actions={[
                                <CloudDownloadOutlined key="download" onClick={(e) => OnDownloadRanking(e, rankingItem)} />
                            ]}
                            headStyle={{ backgroundColor: background }}
                        >
                            <table>
                                <thead>
                                    <tr>
                                        {rankingItem.column_list.map((col, idx) => (
                                            <th key={idx}>{col}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rankingItem.data_list.map((row, rowIndex) => {
                                        let trStyle = {};

                                        if (rankingItem.compare_target_id === 1 && rowIndex === rankingItem.data_list.length - 1) {
                                            trStyle = { fontWeight: 'bold' };
                                        } else if (rankingItem.compare_target_id === 3 && rowIndex === 0) {
                                            trStyle = { fontWeight: 'bold' };
                                        } else {
                                            if (rankingItem.compare_target_id === 2 && rowIndex <= rankingItem.player_id_list.length - 1) {
                                                if ((rankingItem.player_id_list[rowIndex] === player_id) ||
                                                    (rankingItem.team_id_list[rowIndex] === team_id)) {
                                                    trStyle = { fontWeight: 'bold' };
                                                }
                                            }
                                        }

                                        return (
                                            <tr key={rowIndex} style={trStyle}>
                                                {row.map((cell, cellIndex) => (
                                                    <td key={cellIndex}>
                                                        {typeof cell === 'number' && !Number.isInteger(cell) ? cell.toFixed(3) : cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </Card>
                    </div>
                );
            })}
        </Space>
    );
}